import React from 'react';
import { Link } from 'react-router-dom';
import { LogoIcon } from '@src/svg';
import { ContractorFlowSteps } from './ContractorFlowSteps';

type ContractorFlowNavigationProps = {
  className?: string;
  currentStep?: number;
  hideReviewStep?: boolean;
};

export const ContractorFlowNavigation = ({
  className = '',
  currentStep = 1,
  hideReviewStep = false,
}: ContractorFlowNavigationProps) => (
  <aside
    className={`contractor-flow-navigation ${className}`}
    aria-label="Contractor creation navigation"
  >
    <Link to="/" className="contractor-flow-navigation__logo">
      <LogoIcon />
    </Link>
    <ContractorFlowSteps
      currentStep={currentStep}
      hideReviewStep={hideReviewStep}
    />
  </aside>
);
